<div class="column content-container">
	<div class="content-container-body">
		<h3 i18n="@@@addPropertyConfirmation-Review"><b>Review</b></h3>

		<div i18n="@@addPropertyConfirmation-ConfirmationMessage">
			Please confirm the following in order to add the property
		</div>

		<div class="margin-top-24 margin-bottom-24">
			<mat-divider></mat-divider>

			<div class="row spacing-24 margin-top-24 margin-bottom-24">
				<div class="column">
					<div class="color-type-tertiary font-size-caption" i18n="@@addPropertyConfirmation-Name">Property Name</div>
					<div>{{ editProperty.name }}</div>
				</div>
				<div class="column">
					<div class="color-type-tertiary font-size-caption" i18n="@@addPropertyConfirmation-Address">Address</div>
					<div>{{ editProperty.address1 }}, {{ editProperty.locality }}</div>
					<div>
						{{ editProperty.countryCode }}, {{ editProperty.stateProvinceRegion }} {{ editProperty.postalCode }}
					</div>
				</div>
				<div class="column"></div>
				<div class="column"></div>
			</div>

			<mat-divider></mat-divider>

			<div class="flex-container row-no-width margin-top-24">
				<div class="header-margin inline-label-margin" i18n="@@addPropertyDetails-DeviceInsalls">
					Devices to be installed:
				</div>
				<button
					mat-stroked-button
					(click)="decrementOnClick()"
					class="add-property-incremental-button"
					[appHasSystemCapability]
					has="deviceManagement"
					data-automation-id="decrement-button"
				>
					-
				</button>
				<input
					[(ngModel)]="this.editProperty.pendingInstalls"
					[disabled]="true"
					[readonly]="true"
					class="incremental-input"
					data-automation-id="add-property-pending-installs-input"
				/>
				<button
					mat-stroked-button
					(click)="incrementOnClick()"
					class="add-property-incremental-button"
					[appHasSystemCapability]
					has="deviceManagement"
					data-automation-id="increment-button"
				>
					+
				</button>
			</div>
		</div>
	</div>
</div>
